import { Injectable } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { ShareApiService } from './share-api.service';

@Injectable({
  providedIn: 'root'
})
export class SharedataService {
  public isShare: boolean = false;
  public shareType:string = '';
  public uuid:string = '';
  public shareList:any = null;
  public sharingEmails = null;
  public suggestedEmails = '';
  public showSuggestion:boolean = false;

  constructor(public iApiShare: ShareApiService,private notifier:NotifierService) { 
    
   }

   openSharePanel(uuid,type){
    // console.log("opensight call from "+type)
    this.isShare = true;
    this.shareType = type;
    this.uuid = uuid;
    this.getShareData({"uuid":uuid,"type":type});
  }

  close(){
    this.isShare = false;
    this.uuid = '';
    this.shareType = '';
    this.shareList = null;
    this.sharingEmails = [];
    this.showSuggestion = false;
    this.suggestedEmails = '';
  }

  getShareData(obj){
    
    this.iApiShare.getShareData(obj)
    .subscribe(
      result =>{
        if (result['status'] == 1) {
          this.shareList = result['result'].length>0 ? result['result'] : [];
          this.sharingEmails = [];
          // console.log("Shares emails are ===> "+JSON.stringify(result['result']))
        }
      }
    )
  }

  addShareData(body){
    // console.log("body in Share Data ===>> "+JSON.stringify(body));
    this.iApiShare.addShareData(body)
    .subscribe(result =>{
      if (result['status'] == 1) {
        this.notifier.notify('success',result['message']);
        this.getShareData({"uuid":this.uuid,"type":this.shareType});
        this.close();
      }
      else if(result['status'] == 2){
        this.sharingEmails = [];
        this.notifier.notify('error',result['message']);
      }
      else if(result['status'] == 0){
        this.sharingEmails = [];
        this.notifier.notify('error','Something went wrong');
      }
    })
    
  }

}
